import { render, staticRenderFns } from "./userVerify.vue?vue&type=template&id=0b4d01e6&"
import script from "./userVerify.vue?vue&type=script&lang=js&"
export * from "./userVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports